import React from 'react';

const CSS = `
  .infinity {
    position: absolute;
    width: 100%;
    max-width: 400px;
  }
  .infinity path {
    fill: none;
    stroke-width: 10;
    transform-origin: 50% 50%;
  }
  .infinity__outline {
    stroke: #1a1a1a;
    animation: inf-hover 2000ms linear infinite;
  }
  .infinity__tracer {
    stroke-linecap: round;
    opacity: 0.9;
    animation: inf-tracer 500ms linear reverse infinite;
  }
  .infinity__tracer--1 { stroke: #F38181; animation-duration: 3000ms;  animation-delay: -1980ms; }
  .infinity__tracer--2 { stroke: #FCE38A; animation-duration: 1500ms;  animation-delay: -990ms;  }
  .infinity__tracer--3 { stroke: #E23E57; animation-duration: 1000ms;  animation-delay: -660ms;  }
  .infinity__tracer--4 { stroke: #95E1D3; animation-duration: 750ms;   animation-delay: -495ms;  }
  .infinity__tracer--5 { stroke: #FFC4D0; animation-duration: 600ms;   animation-delay: -396ms;  }
  .infinity__tracer--6 { stroke: #00DFFC; animation-duration: 500ms;   animation-delay: -330ms;  }

  @keyframes inf-tracer {
    0%   { stroke-dasharray: 0, 260;    stroke-dashoffset: -234; }
    25%  { transform: translate(-2px, 2px); }
    50%  { stroke-dasharray: 43.3, 260; stroke-dashoffset: -78;  }
    65%  { transform: translate(2px, -2px); }
    100% { stroke-dasharray: 4, 260;    stroke-dashoffset: 0;    }
  }
  @keyframes inf-hover {
    50% { transform: translateY(2px) scale(1.02); }
  }
`;

const PATH = "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z";

const Spinner = ({ label = '' }) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f0f0f' }}>
        <style>{CSS}</style>
        <svg className="infinity" viewBox="0 0 187.3 93.7" preserveAspectRatio="xMidYMid" xmlns="http://www.w3.org/2000/svg">
            <path className="infinity__outline" d={PATH} />
            {[1,2,3,4,5,6].map(i => (
                <path key={i} className={`infinity__tracer infinity__tracer--${i}`} d={PATH} />
            ))}
        </svg>
        {label && <p style={{ color: '#555', fontSize: 13, marginTop: 32 }}>{label}</p>}
    </div>
);

export default Spinner;
